import React, { useEffect } from "react";
import "./AgriculturalCommodities.css";
import Notfound from "../../../Notfound";
import Card from "../../../../components/Card";
import Breadcrumb from "../../../../components/Breadcrum";
const images = {
  ECO: "./assets/img/agriculturalCommodities/product_peanut.png",
  chickpeas: "./assets/img/agriculturalCommodities/chickpeas.jpg",
  fruits: "./assets/img/agriculturalCommodities/fruits.jpg",
  nuts: "./assets/img/agriculturalCommodities/nuts.jpg",
  product_rice: "./assets/img/agriculturalCommodities/product_rice.png",
  product_spices: "./assets/img/agriculturalCommodities/product_spices.png",
  banner: "./assets/img/contact-banner.png",
};

const cardData = [
  {
    id: "fruits-and-vegetables",
    image: images.fruits,
    title: "Fruits & Vegetables",
    redirectionUrl: "/business/agricultural-commodities/FruitsAndVeg",
  },
  {
    id: "spices",
    image: images.product_spices,
    title: "Spices",
    redirectionUrl: "/business/agricultural-commodities/spices",
  },
  {
    id: "rice",
    image: images.product_rice,
    title: "Rice",
    redirectionUrl: "/business/agricultural-commodities/rice",
  },
  {
    id: "chickpeas",
    image: images.chickpeas,
    title: "Chickpeas",
    redirectionUrl: "/business/agricultural-commodities/chickpeas",
  },
  {
    id: "nuts",
    image: images.nuts,
    title: "Nuts",
    redirectionUrl: "/business/agricultural-commodities/nuts",
  },
];
export default function AgriculturalCommodities() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Breadcrumb
        title="Agricultural Commodities"
        backgroundImage={images.banner}
        height="40vh"
      ></Breadcrumb>
      <section className="main-services cardContainer pt-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="service-item mb-5">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="left-image">
                      <img src={images.ECO} alt="Digital Currencies" />
                    </div>
                  </div>
                  <div className="col-lg-8 align-self-center">
                    <div className="right-text-content">
                      <p className="justify">
                        We supply essential Agricultural Commodities that
                        support global food security and industrial needs. From
                        grains like wheat, corn, and rice, to vegetables,
                        fruits, and livestock products, we are dedicated to
                        providing high-quality products that meet the diverse
                        demands of the agricultural industry. In addition to
                        food products, we also offer non-food agricultural
                        commodities such as cotton, rubber, and biofuels. Our
                        commitment to sustainable sourcing ensures that all our
                        agricultural products are grown and harvested with care
                        for the environment, local communities, and global food
                        security. We work directly with farms and suppliers to
                        ensure consistency and quality, delivering products that
                        meet international standards.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="cardContainer mb-5">
        <div className="container">
          <div className="row g-lg-5 g-4">
            {cardData.map((card) => (
              <div key={card.id} className="col-lg-4 col-md-6 col-12">
                <Card
                  key={card.id}
                  image={card.image}
                  title={card.title}
                  id={card.id}
                  description={card.description}
                  redirectionUrl={card.redirectionUrl}
                />
              </div>
            ))}

          </div>
        </div>
      </div>
    </>
  );
}
